import fetch from 'utils/fetch';

export const renderCreate = invoiceId => {
  const url = `/pco-manager/invoices/${invoiceId}/payments/new`;
  return fetch(url).then(res => res.text());
};

export const renderEdit = paymentId => {
  const url = `/pco-manager/invoices/payments/line/${paymentId}`;
  return fetch(url).then(res => res.text());
};

export const save = (data, invoiceId) =>
  fetch(`/pco-manager/invoices/${invoiceId}/payments`, {
    method: 'POST',
    body: data,
  });

export const remove = paymentId =>
  fetch(`/pco-manager/invoices/payments/line/${paymentId}`, {
    method: 'DELETE',
  });



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/payments/api/index.js